import { useMutation } from '@apollo/client'
import { useEffect, useRef } from 'react'

import { APP_ENV } from 'src/env'
import { SEND_PING } from 'src/schema/mutations'
import { handlePromise } from 'src/utils/handlePromise'
import logger from 'src/utils/logger'

/**
 * Ping interval in seconds
 * @type {number}
 */
export const PING_INTERVAL = 10 * 1000

/**
 * Upserts a row into `simulation.activeUsers`
 * every interval seconds
 */
const useSimulationActivePing = (isSimulationEnabled, apolloClient) => {
    const [sendPing] = useMutation(SEND_PING, { client: apolloClient })
    const timerRef = useRef(null)

    useEffect(() => {
        async function run() {
            logger.debug('pinged!')
            const [pingError] = await handlePromise(sendPing())
            if (pingError) {
                logger.error('an error occurred while sending ping')
                logger.error(pingError)
            }
        }

        if (isSimulationEnabled) {
            if (APP_ENV.REACT_APP_LOCAL === 'yes') {
                logger.warn('skipped active ping')
                return
            }

            timerRef.current = setInterval(run, PING_INTERVAL)
        }

        return () => {
            clearInterval(timerRef?.current)
        }
    }, [sendPing, isSimulationEnabled])
}

export default useSimulationActivePing
